import React from "react";
import {
  AreaChart,
  Area,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { useTranslation } from "react-i18next";
import {
  primaryColor,
  secondaryColor,
  tooltipContentStyle,
  tooltipCursorStyle,
} from "utils/dashboardUtils";

const MembershipGrowthChart = ({ membershipGrowth }) => {
  const { t } = useTranslation();
  const MEMBERSHIP_GROWTH_DATA = membershipGrowth?.map((item) => ({
    month: item.label, // Jan, Feb
    total: item.newMembers, // total members
    signup: item.newSignups, // signups
  }));

  return (
    <div className="membership_growth dashboard_common_card">
      {/* Title */}
      <div className="d-flex justify-content-between align-items-center mb-5">
        <div>
          <h3 className="fs_20">{t("Membership Growth")}</h3>
          <p className="page_sub_title mt-2">
            {t("Total active members over the last 6 months")}
          </p>
        </div>
        {/* Legend */}
        <div className="legends">
          <div className="inner_legend">
            <span className="dot total_dot" />
            {t("New Members")}
          </div>

          <div className="inner_legend">
            <span className="dot new_dot" />
            {t("New Signups")}
          </div>
        </div>
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={MEMBERSHIP_GROWTH_DATA}>
          <defs>
            <linearGradient id="membersGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={primaryColor} stopOpacity={0.4} />
              <stop offset="100%" stopColor={primaryColor} stopOpacity={0} />
            </linearGradient>
          </defs>

          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: secondaryColor, fontSize: 12, fontWeight: 500 }}
            tickMargin={15}
          />

          <YAxis hide />

          <Tooltip
            cursor={tooltipCursorStyle}
            formatter={(value, name) => [
              value,
              name === "total" ? t("New Members") : t("New Signups"),
            ]}
            contentStyle={tooltipContentStyle}
            labelStyle={{ fontWeight: 600 }}
          />

          {/* Horizontal lines */}
          <CartesianGrid
            vertical={false}
            stroke="#E6EAF0"
            strokeDasharray="0"
          />

          {/* Area + Line for Total Members */}
          <Area
            type="monotone"
            dataKey="total"
            stroke={primaryColor}
            strokeWidth={2}
            fill="url(#membersGradient)"
            dot={{ r: 4, fill: "#fff", stroke: primaryColor, strokeWidth: 2 }}
            activeDot={{ r: 6 }}
          />

          {/* Dotted line for New Signups */}
          <Line
            type="monotone"
            dataKey="signup"
            stroke={secondaryColor}
            strokeWidth={2}
            strokeDasharray="3 4"
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MembershipGrowthChart;
